import { render } from "./AdminAlgorithmSettingsView.vue?vue&type=template&id=cc57470a&scoped=true&ts=true"
import script from "./AdminAlgorithmSettingsView.vue?vue&type=script&lang=ts"
export * from "./AdminAlgorithmSettingsView.vue?vue&type=script&lang=ts"

import "./AdminAlgorithmSettingsView.vue?vue&type=style&index=0&id=cc57470a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc57470a"]])

export default __exports__